import React, { useState, useRef } from 'react';
import Header from './Header';
import Footer from './Footer';

export default function PhotographyLayout({ children }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const scrollRef = useRef(null);

  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollTop = scrollRef.current.scrollTop;
      setIsScrolled(scrollTop > window.innerHeight * 0.5);
    }
  };

  return (
    <div 
      id="photo-scroll"
      ref={scrollRef}
      onScroll={handleScroll}
      // UPDATE: snap-y dan snap-mandatory HANYA diawali dengan md:
      // h-[100dvh] tetap dipertahankan agar tinggi layar akurat di HP
      className="h-[100dvh] w-full overflow-y-scroll md:snap-y md:snap-mandatory scroll-smooth bg-white text-butter-text selection:bg-butter-line selection:text-butter-dark font-butter-sans relative"
    >
      <Header isScrolled={isScrolled} />
      <main className="flex-grow flex flex-col">
        {children}
      </main>
      <Footer />
    </div>
  );
}